const Login = () => import('@/views/auth/login')

export default [
  {
    path: '/login',
    name: 'Login',
    component:  Login,
  },
]
